import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PlusCircle, Loader2, FileText } from "lucide-react";
import { StatusBadge, brl, fdate } from "@/pages/portal/Dashboard";

export default function MeusOrcamentos() {
  const [quotes, setQuotes] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/quote-requests");
        setQuotes(data);
      } catch {
        setQuotes([]);
      }
    })();
  }, []);

  return (
    <div data-testid="portal-quotes-page">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="display text-3xl sm:text-4xl font-extrabold uppercase">Meus Orçamentos</h1>
          <p className="mt-1 text-sm text-zinc-500">Acompanhe o status de cada solicitação.</p>
        </div>
        <Link
          to="/painel/orcamentos/novo"
          data-testid="portal-quotes-new-button"
          className="inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-500 text-white text-sm font-semibold uppercase tracking-wider px-5 py-2.5 rounded-sm transition-colors"
        >
          <PlusCircle className="w-4 h-4" /> Novo Orçamento
        </Link>
      </div>

      <div className="mt-8 card-tactical rounded-md overflow-hidden">
        {!quotes ? (
          <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-zinc-600" /></div>
        ) : !quotes.length ? (
          <div className="py-16 text-center" data-testid="portal-quotes-empty">
            <FileText className="w-10 h-10 text-zinc-700 mx-auto" strokeWidth={1.25} />
            <p className="mt-4 text-sm text-zinc-500">Você ainda não possui orçamentos.</p>
            <Link
              to="/painel/orcamentos/novo"
              className="mt-2 inline-block text-sm font-medium text-orange-500 hover:text-orange-400"
            >
              Solicitar o primeiro orçamento
            </Link>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm" data-testid="portal-quotes-table">
              <thead>
                <tr className="text-left text-xs uppercase tracking-wider text-zinc-500 border-b border-zinc-800">
                  <th className="px-5 py-3.5 font-medium">Número</th>
                  <th className="px-5 py-3.5 font-medium">Data</th>
                  <th className="px-5 py-3.5 font-medium">Serviço</th>
                  <th className="px-5 py-3.5 font-medium">Peça</th>
                  <th className="px-5 py-3.5 font-medium text-right">Qtd.</th>
                  <th className="px-5 py-3.5 font-medium text-right">Valor</th>
                  <th className="px-5 py-3.5 font-medium">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800/70">
                {quotes.map((q) => (
                  <tr key={q.id} className="hover:bg-zinc-900/50 transition-colors" data-testid={`portal-quote-row-${q.number}`}>
                    <td className="px-5 py-3.5 mono text-zinc-200">{q.number}</td>
                    <td className="px-5 py-3.5 text-zinc-400">{fdate(q.created_at)}</td>
                    <td className="px-5 py-3.5 text-zinc-300 max-w-[240px] truncate" title={(q.services?.length ? q.services.join(" + ") : q.service_type) || ""}>
                      {(q.services?.length ? q.services.join(" + ") : q.service_type) || "—"}
                    </td>
                    <td className="px-5 py-3.5 text-zinc-400 max-w-[220px] truncate" title={q.part_name}>{q.part_name}</td>
                    <td className="px-5 py-3.5 mono text-right text-zinc-300">{q.quantity}</td>
                    <td className="px-5 py-3.5 mono text-right text-zinc-200">
                      {q.value != null ? brl(q.value) : "—"}
                    </td>
                    <td className="px-5 py-3.5"><StatusBadge status={q.status} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
